module.exports = __webpack_public_path__ + "img/child-room.acb9f314.svg";